import { runtimeEnv } from 'config/runtimeEnv';
// src/services/QrPaymentReportService.js
import requestInstance from './Request';
import { setCurrentUser } from 'utils/utils';

const env = runtimeEnv('B2B_API_BASE_URL');

/**
 * GET /admin-api/v3/reports/qr-payments
 * Supported params: page, pageSize, dateFrom, dateTo, city, companyId,
 *                   tripStatus, paymentStatus, settlementStatus
 */
export const getQrPaymentReportList = async (params = {}) => {
  const page = params?.page === 0 || params?.page ? params.page + 1 : 1;

  let url = `${env}/admin-api/v3/reports/qr-payments?page=${page}&pageSize=${params.pageSize || 10}`;
  if (params.dateFrom) url += `&dateFrom=${params.dateFrom}`;
  if (params.dateTo) url += `&dateTo=${params.dateTo}`;
  if (params.city) url += `&city=${params.city}`;
  if (params.companyId) url += `&companyId=${params.companyId}`;
  if (params.tripStatus) url += `&tripStatus=${params.tripStatus}`;
  if (params.paymentStatus) url += `&paymentStatus=${params.paymentStatus}`;
  if (params.settlementStatus) url += `&settlementStatus=${params.settlementStatus}`;

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

/**
 * POST /admin-api/v3/tasks/report
 * Generates CSV/PDF report. Pass notifyOnComplete: true to email the report.
 */
export const requestQrPaymentReport = async ({
  startDate,
  endDate,
  format = 'csv',
  filters = {},
  notifyOnComplete = false,
}) => {
  const payload = {
    startDate,
    endDate,
    reportType: 'B2B_QR_PAYMENT_OPERATIONS_REPORT',
    reportFormate: format,
    notifyOnComplete,
    filters: {
      isB2B: true,
      city: filters.city || '',
      companyId: filters.companyId || '',
      tripStatus: filters.tripStatus || '',
      paymentStatus: filters.paymentStatus || '',
      settlementStatus: filters.settlementStatus || '',
    },
  };

  const res = await requestInstance
    .post(`${env}/admin-api/v3/tasks/report`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

/**
 * GET /admin-api/v3/tasks/report?reportType=B2B_QR_PAYMENT_OPERATIONS_REPORT
 * Returns history of generated reports (status, downloadLink, expiry, etc.)
 */
export const getQrPaymentReportHistory = async ({ page = 0, pageSize = 10 } = {}) => {
  const pageNum = page === 0 || page ? page + 1 : 1;
  const url = `${env}/admin-api/v3/tasks/report?reportType=B2B_QR_PAYMENT_OPERATIONS_REPORT&page=${pageNum}&pageSize=${pageSize}&isB2B=true`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
